import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d312e9ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "event-container" }
const _hoisted_2 = { class: "event-header" }
const _hoisted_3 = { class: "event-content" }
const _hoisted_4 = { class: "event-main" }
const _hoisted_5 = { class: "event-sidebar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventGuestHeader = _resolveComponent("EventGuestHeader")!
  const _component_EventGuestImage = _resolveComponent("EventGuestImage")!
  const _component_EventGuestTitleBar = _resolveComponent("EventGuestTitleBar")!
  const _component_EventSchedule = _resolveComponent("EventSchedule")!
  const _component_SocialMediaButtons = _resolveComponent("SocialMediaButtons")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Copyrights = _resolveComponent("Copyrights")!
  const _component_Contact = _resolveComponent("Contact")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_EventGuestHeader, {
        programs: _ctx.programs,
        routeName: _ctx.schedule,
        params: { type: 'TYPE', id: 'ID' },
        stateMenuFilter: this.sortedDays()[0]
      }, null, 8, ["programs", "routeName", "stateMenuFilter"])
    ]),
    _createElementVNode("article", _hoisted_3, [
      _createElementVNode("section", _hoisted_4, [
        _withDirectives(_createVNode(_component_EventGuestImage, { image: _ctx.image }, null, 8, ["image"]), [
          [_vShow, !_ctx.image.includes('undefined')]
        ]),
        _createVNode(_component_EventGuestTitleBar, {
          eventTitle: _ctx.name,
          tagText: _ctx.tags,
          country: _ctx.country,
          origin: "anEvent"
        }, null, 8, ["eventTitle", "tagText", "country"]),
        _createVNode(_component_EventSchedule, {
          date: _ctx.day,
          hour: _ctx.hour,
          place: _ctx.place,
          link: _ctx.link,
          name: _ctx.name
        }, null, 8, ["date", "hour", "place", "link", "name"])
      ]),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", {
          style: _normalizeStyle([
            this.facebook ||
            this.deezer ||
            this.twitter ||
            this.youtube ||
            this.spotify ||
            this.instagram ||
            this.soundcloud
              ? { display: 'flex' }
              : { display: 'none' },
          ])
        }, [
          _createVNode(_component_SocialMediaButtons, {
            instagram: _ctx.instagram,
            twitter: _ctx.twitter,
            facebook: _ctx.facebook,
            deezer: _ctx.deezer,
            spotify: _ctx.spotify,
            soundcloud: _ctx.soundcloud,
            youtube: _ctx.youtube
          }, null, 8, ["instagram", "twitter", "facebook", "deezer", "spotify", "soundcloud", "youtube"])
        ], 4),
        _createVNode(_component_TextField, { text: _ctx.description }, null, 8, ["text"]),
        _createVNode(_component_Copyrights, {
          text: _ctx.copyright,
          description: _ctx.description
        }, null, 8, ["text", "description"]),
        _createVNode(_component_Contact, {
          telephone: _ctx.telephone,
          website: _ctx.website,
          email: _ctx.email
        }, null, 8, ["telephone", "website", "email"])
      ])
    ])
  ]))
}